module.exports = __webpack_public_path__ + "static/media/img-hero.73d47df0.jpg";